module.exports = __webpack_public_path__ + "img/icon_system_dictionary_local.33d4a575.svg";